import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import V1Home from './pages/v1/V1Home';
import V2Home from './pages/v2/V2Home';
import V2Index from './pages/v2/V2Index';
import SetupCreateForm from './pages/v2/setup/SetupCreateForm';
import SetupModifyForm from './pages/v2/setup/SetupModifyForm';
import SetupViewPage from './pages/v2/setup/SetupViewPage';
import AssessmentCreateForm from './pages/v2/assessment/AssessmentCreateForm';
import AssessmentModifyForm from './pages/v2/assessment/AssessmentModifyForm';
import AssessmentViewForm from './pages/v2/assessment/AssessmentViewForm';
import AssessmentViewPage from './pages/v2/assessment/AssessmentViewPage';
import AssessmentHome from './pages/v2/assessment/AssessmentHome';
import Dashboard from './pages/v2/Dashboard';
import GuestHome from './pages/GuestHome';
import { PageLayout } from './components/PageLayout';

import './App.css';

import Home from './pages/Home';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import AssessmentHomePage from './pages/v2/assessment/AssessmentHomePage';

function App() {
  const {instance, accounts} = useMsal()
  const username = accounts[0] && accounts[0].username

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        <Routes basename="/fast2">
            <Route path="/" element={<PageLayout />}>
                <Route index element={<V2Home />} />
                <Route path="setup">
                  <Route path="new" element={<SetupCreateForm username={username} />} />
                  <Route path="edit/:setupId" element={<SetupModifyForm username={username} />} />
                  <Route path="view/:setupId" element={<SetupViewPage />} />
                </Route>
                <Route path="assessment" element={<AssessmentHome />}>
                  <Route path="new" element={<AssessmentHomePage mode="create" username={username} />}/>
                  <Route path="edit/:assessmentId" element={<AssessmentHomePage mode="modify" username={username} />} />
                  <Route path="view/:assessmentId" element={<AssessmentViewForm />} />
                  <Route path="view" element={<AssessmentViewForm />} />                  
                </Route>
                <Route path="dashboard" element={<Dashboard />} />
            </Route>
        </Routes>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Routes basename="/fast2">
          <Route path="/" element={<PageLayout />}>
            <Route index element={<GuestHome />} />
          </Route>
        </Routes>
      </UnauthenticatedTemplate>
    </React.Fragment>
  );
}

export default App;
